import * as tslib_1 from "tslib";
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var EdadfortyService = /** @class */ (function () {
    function EdadfortyService(http) {
        this.http = http;
        this.cargadoEdadforty = true;
        this.edadforty = [];
        this.edadfortyRFL = [];
        this.edadfortyRFC = [];
        this.edadfortyRFP = [];
        this.edadfortyRCL = [];
        this.edadfortyRCC = [];
        this.edadfortyRCP = [];
        this.edadfortyRCC_PSen = [];
        this.edadfortyRCC_PSec = [];
        this.cargarEdadforty();
    }
    EdadfortyService.prototype.cargarEdadforty = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.http.get('assets/data/dataLineas.json')
                .subscribe(function (resp) {
                _this.edadforty = resp;
                _this.edadfortyRFL = _this.edadforty[2].rutinafacial.limpieza;
                _this.edadfortyRFC = _this.edadforty[2].rutinafacial.cuidado;
                _this.edadfortyRFP = _this.edadforty[2].rutinafacial.proteccion;
                _this.edadfortyRCL = _this.edadforty[2].rutinacorporal.limpieza;
                _this.edadfortyRCC = _this.edadforty[2].rutinacorporal.cuidado;
                _this.edadfortyRCP = _this.edadforty[2].rutinacorporal.proteccion;
                _this.edadfortyRCC_PSen = _this.edadforty[2].rutinacorporal.cuidado_piel_sensible;
                _this.edadfortyRCC_PSec = _this.edadforty[2].rutinacorporal.cuidado_piel_seca;
                setTimeout(function () {
                    _this.cargadoEdadforty = false;
                }, Math.floor(Math.random() * (1600 - 600)) + 600);
                resolve();
            });
        });
    };
    EdadfortyService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    EdadfortyService = tslib_1.__decorate([
        Injectable({
            providedIn: 'root'
        })
    ], EdadfortyService);
    return EdadfortyService;
}());
export { EdadfortyService };
//# sourceMappingURL=edadforty.service.js.map